/**
 * Topic Author Actions Component
 * 
 * Shows actions available to the topic author (edit first post, delete topic)
 */

import React from 'react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { MoreVertical, Edit, Trash2, Lock, Unlock } from 'lucide-react'

interface TopicAuthorActionsProps {
  topicId: string
  firstPostId: string
  isLocked: boolean
  onEditPost: () => void
  onLock: () => Promise<void>
  onUnlock: () => Promise<void>
  onDelete: () => void
}

export function TopicAuthorActions({
  topicId,
  firstPostId,
  isLocked,
  onEditPost,
  onLock,
  onUnlock,
  onDelete,
}: TopicAuthorActionsProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
        >
          <MoreVertical className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem
          onClick={onEditPost}
          className="cursor-pointer"
        >
          <Edit className="w-4 h-4 mr-2 text-primary" />
          <span>Editar Tópico</span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        {isLocked ? (
          <DropdownMenuItem
            onClick={onUnlock}
            className="cursor-pointer"
          >
            <Unlock className="w-4 h-4 mr-2 text-success" />
            <span>Destrancar Tópico</span>
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            onClick={onLock}
            className="cursor-pointer"
          >
            <Lock className="w-4 h-4 mr-2 text-warning" />
            <span>Trancar Tópico</span>
          </DropdownMenuItem>
        )}
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem
          onClick={onDelete}
          className="cursor-pointer text-destructive focus:text-destructive focus:bg-destructive/10"
        >
          <Trash2 className="w-4 h-4 mr-2" />
          <span>Deletar Tópico</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
